import { PayloadAction } from "@reduxjs/toolkit";
import { IPagination } from "app/types";
import { createSlice } from "utils/@reduxjs/toolkit";
import { initialState } from "./initialState";
import { IFavoriteItem } from "./types";

const FavoriteSlice = createSlice({
  name: "favoriteState",
  initialState,
  reducers: {
    fetchFavoriteListRequest: (state) => {
      state.loading = true;
    },
    fetchFavoriteListSuccess: (
      state,
      action: PayloadAction<Array<IFavoriteItem>>,
    ) => {
      state.loading = false;
      if (state.pagination.page === 1) {
        state.favorites = action.payload;
      } else {
        const newItems = action.payload.filter(
          (newItem) =>
            !state.favorites.some((item) => item.itemId === newItem.itemId),
        );
        state.favorites = [...state.favorites, ...newItems];
      }
    },
    fetchFavoriteListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateFavoriteStatusRequest: (
      state,
      action: PayloadAction<{
        data: { itemId: string; type: string };
        callback: () => void;
      }>,
    ) => {
      state.updateFavoriteLoading = true;
    },
    endUpdateFavoriteStatusRequest: (state) => {
      state.updateFavoriteLoading = false;
    },
    updateFavoriteStatusSuccess: (state, action: PayloadAction<string>) => {
      state.favorites = state.favorites.filter(
        (item) => item.itemId !== action.payload,
      );
    },
    setIsSearching: (state, action: PayloadAction<boolean>) => {
      state.isSearching = action.payload;
      if (!action.payload) {
        state.searchValue = "";
      }
    },
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.searchValue = action.payload;
      state.pagination.page = 1;
      state.loading = true;
    },
    setOpenModalId: (state, action: PayloadAction<string | null>) => {
      state.openModalId = action.payload;
    },
    setPagination: (state, action: PayloadAction<IPagination>) => {
      state.pagination = action.payload;
    },
    loadMore: (state) => {
      if (state.pagination.page < state.pagination.totalPage) {
        state.pagination.page += 1;
        state.loading = true;
      }
    },
  },
});

export const {
  actions,
  reducer: favoriteReducer,
  name: favoriteSlice,
} = FavoriteSlice;
